import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  startAfter,
  where,
  DocumentSnapshot,
  Timestamp,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "../firebase-config";

export interface UserRecord {
  uid: string;
  email: string;
  createdAt: Timestamp;
  isAdmin: boolean;
  enterpriseId: string | null;
  licensed: boolean;
}

export async function getUsers(
  pageSize: number = 50,
  lastDoc?: DocumentSnapshot
): Promise<{ users: UserRecord[]; lastDoc: DocumentSnapshot | null }> {
  let q = query(
    collection(db, "users"),
    orderBy("createdAt", "desc"),
    limit(pageSize)
  );

  if (lastDoc) {
    q = query(q, startAfter(lastDoc));
  }

  const snapshot = await getDocs(q);
  const users: UserRecord[] = snapshot.docs.map((doc) => ({
    uid: doc.id,
    ...doc.data(),
  })) as UserRecord[];

  const last = snapshot.docs.length > 0 ? snapshot.docs[snapshot.docs.length - 1] : null;
  return { users, lastDoc: last };
}

export async function searchUsers(emailQuery: string): Promise<UserRecord[]> {
  // Firestore doesn't support full-text search, so we do prefix matching
  const q = query(
    collection(db, "users"),
    where("email", ">=", emailQuery),
    where("email", "<=", emailQuery + "\uf8ff"),
    limit(20)
  );

  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({
    uid: doc.id,
    ...doc.data(),
  })) as UserRecord[];
}

export async function setUserLicense(
  uid: string,
  licensed: boolean
): Promise<{ success: boolean; uid: string; licensed: boolean }> {
  const callable = httpsCallable<
    { uid: string; licensed: boolean },
    { success: boolean; uid: string; licensed: boolean }
  >(functions, "setUserLicense");
  const result = await callable({ uid, licensed });
  return result.data;
}
